import { EmptyStateProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: EmptyStateProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as EmptyStateProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      subtitle:
        'Create your product item in an easy & fast way to display it on your site',
      theme: 'page',
      title: " You don't have any items yet",
    } as EmptyStateProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
